import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceTestConfiguration } from '../../services/DeviceService';
import { DeviceTestConfiguration } from '../../types/Devices';

function useGetDeviceTestConfiguration(
  deviceId: string,
  fleetId: string,
): UseQueryResult<DeviceTestConfiguration> {
  return useQuery(
    ['device-test-configuration', deviceId, fleetId],
    async (): Promise<DeviceTestConfiguration> => getDeviceTestConfiguration(deviceId, fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: !!deviceId && !!fleetId,
    },
  );
}

export default useGetDeviceTestConfiguration;
